import { CONSTANT_TEXTS } from '@gp/constants/const';
import FeeUpdatedHistoriesBubble from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/MilestoneForm/FeeUpdatedHistoriesBubble';
import FinancialsForecastTable from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/UpdateGRModal/FinancialsFormControl/ForecastTable';
import FinancialsTable from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/UpdateGRModal/FinancialsFormControl/Table';
import {
  getInitialKeyMilestonesFinancials,
  getInitialKeyMilestonesFinancialsForecast,
} from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/UpdateGRModal/FinancialsFormControl/utils';
import TipContext from '@home/components/TipContext';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { FormItem, FormText } from 'tea-component';

import type {
  IFeeUpdatedHistory,
  IMilestone,
} from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import type { IMilestoneFinancialForecastVO, IMilestoneFinancialVO } from '@gp/types/milestones';
import type { IBaseProps } from '@home/types/common';

interface IFinancialsProps extends IBaseProps {
  milestoneDevCostEditable: boolean;
  milestoneDevCostFeeShow: boolean;
  milestoneDevCostFeeFixed: string;
  milestoneFinancialsEditable: boolean;
  milestoneDevCostFeeDataInfo: {
    milestoneFeeUpdatedHistoriesShow: boolean;
    milestoneFeeUpdatedHistories: IFeeUpdatedHistory[];
  };
  currentMilestoneDate?: string;
  separatedMilestones?: IMilestone[];
  milestonesFinancials?: IMilestoneFinancialVO[] | null;
  milestonesFinancialsForecast?: IMilestoneFinancialForecastVO[] | null;
}

const Financials: React.FC<IFinancialsProps> = (props) => {
  const {
    style,
    className,
    milestoneDevCostEditable,
    milestoneDevCostFeeShow,
    milestoneDevCostFeeFixed,
    milestoneFinancialsEditable,
    milestoneDevCostFeeDataInfo,
    currentMilestoneDate,
    separatedMilestones,
    milestonesFinancials,
    milestonesFinancialsForecast,
  } = props;

  const financials = useMemo<IMilestoneFinancialVO[]>(
    () =>
      getInitialKeyMilestonesFinancials(
        milestonesFinancials || [],
        currentMilestoneDate,
        separatedMilestones,
        false,
      ),
    [currentMilestoneDate, milestonesFinancials, separatedMilestones],
  );

  const financialsForecast = useMemo<IMilestoneFinancialForecastVO[]>(
    () => getInitialKeyMilestonesFinancialsForecast(milestonesFinancialsForecast),
    [milestonesFinancialsForecast],
  );

  return (
    <FormItem
      style={style}
      className={classnames('dbg-milestone-form-financials', className)}
      label="Financials"
    >
      {milestoneDevCostEditable && (
        <div className="dbg-milestone-form-financials-top">
          <FormText className="dbg-milestone-form-text">
            {CONSTANT_TEXTS.APPROVED_DEVELOPMENT_BUDGET}:&nbsp;
            <div className="dbg-pdetail-budget">
              {milestoneDevCostFeeShow || '-'}
              {milestoneDevCostFeeShow && (
                <div className="dbg-pdetail-budget-text">
                  <span title={milestoneDevCostFeeFixed}>{milestoneDevCostFeeFixed}</span>
                  &nbsp;M$
                </div>
              )}
              {milestoneDevCostFeeDataInfo.milestoneFeeUpdatedHistoriesShow && (
                <TipContext
                  overlayMaxHeight={250}
                  placement="right"
                  tipText={
                    <FeeUpdatedHistoriesBubble
                      histories={milestoneDevCostFeeDataInfo.milestoneFeeUpdatedHistories}
                    />
                  }
                />
              )}
            </div>
          </FormText>
        </div>
      )}
      {milestoneFinancialsEditable && (
        <div className="dbg-milestone-form-financials__table-card-list">
          <div className="dbg-milestone-form-financials__table-card-item dbg-milestone-form-financials__table-card">
            <div className="dbg-milestone-form-financials__table-card-title">
              Development Cost & Headcount By Milestone
            </div>
            <FinancialsTable
              currentMilestoneDate={currentMilestoneDate}
              milestones={separatedMilestones}
              value={financials}
            />
          </div>
          <div className="dbg-milestone-form-financials__table-card-item dbg-milestone-form-financials__table-card">
            <div className="dbg-milestone-form-financials__table-card-title">
              Forecast Financials
            </div>
            <FinancialsForecastTable value={financialsForecast} />
          </div>
        </div>
      )}
    </FormItem>
  );
};

export default Financials;
